
/* injects from baggage-loader */

import omit from 'lodash/omit'
import get from 'lodash/get'
import set from 'lodash/set'
import loadTypes from 'utils/loadTypes'
import parseDate from 'utils/parseDate'
import startOfDay from 'date-fns/start_of_day'
import endOfDay from 'date-fns/end_of_day'
import moment from 'moment'

export const REPORTS = loadTypes('REPORTS')
export const REPORT = loadTypes('REPORT')
export const REPORT_SET_DATE_RANGE = 'REPORT_SET_DATE_RANGE'
export const REPORTS_ADD = loadTypes('REPORTS_ADD')
export const REPORTS_DELETE = loadTypes('REPORTS_DELETE')
export const REPORTS_DATA = loadTypes('REPORTS_DATA')
export const REPORTS_CHART_DATA = loadTypes('REPORTS_CHART_DATA')
export const REPORTS_SET_DATA = 'REPORTS_SET_DATA'
export const REPORTS_SET_TOTAL = 'REPORTS_SET_TOTAL'

export default function reports(state = null, action) {
  switch (action.type) {
    case REPORTS.SUCCESS:
      return action.response.reduce((acc, report) => {
        acc[report.id] = reportReducer(report)
        return acc
      }, {})

    case REPORT.SUCCESS:
    case REPORTS_ADD.SUCCESS:
      return {
        ...state,
        [action.response.id]: reportReducer(action.response)
      }

    case REPORTS_DELETE.SUCCESS:
      const {reportId} = action.params

      return {
        ...omit(state, [reportId])
      }

    case REPORTS_SET_DATA:
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          data: action.data
        }
      }

    case REPORTS_SET_TOTAL:
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          total: action.total
        }
      }

    case REPORT_SET_DATE_RANGE:
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          startDate: action.startDate,
          endDate: action.endDate,
          dynamicDateType: action.dynamicDateType
        }
      }

    case REPORTS_CHART_DATA.SUCCESS:
      return {
        ...state,
        [action.params.reportId]: reportChartReducer(
          state[action.params.reportId],
          action.params.chartIndex,
          action.params.dimensionIndex,
          action.response
        )
      }

    default:
      return state
  }
}

export function reportChartReducer(report, chartIndex, dimensionIndex, chartData) {
  const {charts = []} = report
  const chart = get(charts, [chartIndex], {})
  return {
    ...report,
    charts: [
      ...charts.slice(0, chartIndex),
      {
        ...chart,
        data: chartDataReducer(get(chart, ['data'], {}), chartData, dimensionIndex, chart.metric)
      },
      ...charts.slice(chartIndex + 1)
    ]
  }
}

export function chartDataReducer(chartData = {}, newChartData, dimensionIndex, metric) {
  return {
    ...chartData,
    ...newChartData.reduce((acc, day) => {
      const date = moment(day.day).clone().toDate()
      acc[date] = get(chartData, [date], []).concat()
      set(acc, [date, dimensionIndex], day[metric])
      return acc
    }, {})
  }
}

function reportReducer(report) {
  return {
    ...report,
    createdAt: report.createdAt ? parseDate(report.createdAt) : null,
    startDate: report.startDate ? report.startDate : null,
    endDate: report.endDate ? report.endDate : null
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/reports/index.js